import React from 'react';
import classNames from 'classnames';
import { ReactComponent as Icon } from '../chevron.svg';
import { ReactComponent as IconBold } from '../chevron2.svg';
import { ChevronDirection } from './enums/ChevronDirection';
import classes from './ChevronIcon.module.scss';

interface IProps extends React.SVGProps<SVGSVGElement> {
    title?: string;
    bold?: boolean;
    direction: ChevronDirection;
}

export const ChevronIcon: React.FC<IProps> = ({ direction, bold, ...props }) => {
    const Component = bold ? IconBold : Icon;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} className={classNames(props.className, classes[direction])} />;
};
